/**
 * A context return function.
 */
interface ContextFn {
  /**
   * Gets the imported data for the specified path.
   * @param path The path to get the data for.
   * @returns The data, if any.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (path: string): any;
}

/**
 * Provides a declaration for the webpack `require.context` method.
 */
interface WebpackContextRequire {
  /**
   * Creates a new webpack context.
   * @param path The path to create the context under.
   * @param deep Whether to search child directories.
   * @param pattern The pattern for files to locate.
   */

  context(path: string, deep?: boolean, pattern?: RegExp): ContextFn;
}

/**
 * The default icon provider.
 * @returns Always undefined.
 */
function DefaultIconProvider(): unknown {
  return undefined;
}

let availableIcons: ContextFn = DefaultIconProvider;
let iconContextLoaded = false;
let didWarnContext = false;

try {
  availableIcons = (require as unknown as WebpackContextRequire).context("!@svgr/webpack!./icons", true, /\.svgi$/);
  iconContextLoaded = true;
} catch {
  if (!didWarnContext && typeof process !== "undefined" && process.env?.NODE_ENV !== "production" && process.env?.NODE_ENV !== "test") {
    didWarnContext = true;
    console.warn(
      "[capitalrx-components] Icon webpack context (require.context) is unavailable. "
        + "All icons will resolve to null. This is expected in SSR or non-webpack builds, "
        + "but may indicate misconfiguration in a browser webpack bundle.",
    );
  }
}

export { availableIcons, iconContextLoaded };
